import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  notificationActions,
  getNotifications,
  Notification_Types,
  Notification_Actions,
} from "@sf-core";
import { toastActions } from "@base-provider";
import { useTranslation } from "react-i18next";

const NotificationLayout = () => {
  const { t } = useTranslation();
  useEffect(() => {
    fetchNotifications();
    const notificationsInterval = setInterval(() => {
      fetchNotifications();
    }, 1 * 10 * 1000);

    return () => clearInterval(notificationsInterval); //This is important
  }, []);
  const dispatch = useDispatch();

  const fetchNotifications = () => {
    getNotifications()
      .then((res) => {
        if (res && res.data) {
          //we're showing toasts only for the ones that are not delivered and are popups
          let toasts = res.data.filter((x) => x.isPopup && !x.sentAt);
          if (toasts.length > 0) {
            // if the toasts to be shown are 4 or more show 1 toast to inform user about new notifications  
            if (toasts.length > 3)
              dispatch(
                toastActions.showInfoMessage({
                  title: t("components.toast.newNotificationsTitle", {
                    count: toasts.length,
                  }),
                  detail: t("components.toast.newNotificationsDetail", {
                    count: toasts.length,
                  }),
                  customAction: Notification_Actions.VIEW,
                  actionLabel: t("components.toast.newNotificationsActionLabel"),
                })
              );
            else {
              toasts.forEach((toast) => {
                switch (toast.type) {
                case Notification_Types.INFO:
                default:
                  dispatch(toastActions.showInfoMessage(toast));
                  break;
                case Notification_Types.SUCCESS:
                  dispatch(toastActions.showSuccessMessage(toast));
                  break;
                case Notification_Types.ERROR:
                  dispatch(toastActions.showErrorMessage(toast));
                  break;
                case Notification_Types.WARNING:
                  dispatch(toastActions.showWarningMessage(toast));
                  break;
                case Notification_Types.REMINDER:
                  dispatch(toastActions.showReminderMessage(toast));
                  break;
                }
              });
            }
          }
          dispatch(notificationActions.setNotifications(res.data));
        }
      })
      .catch((error) => {
        //error management
      });
  };

  return null;
};

export default NotificationLayout;